<div class="flex flex-col flex-auto min-w-0">
    <div class="flex-auto">
        <div class="h-full max-content-h">
            <div class="drk-page-wrapper">

                <ng-template #tabContentTemplate let-tab="tab">
                    <div class="drk-tab-content relative w-full h-full min-h-[500px]" *ngIf="tab.tabMode == 'FRE'">
                        <div class="drk-component-free absolute" *ngFor="let c of tab.tabComponents"
                            [style.width.%]="c.componentSizeW / 30 * 100" [style.height]="c.componentSizeH > 0 ? (c.componentSizeH / 30 * 100) + '%' : 'auto'"
                            [style.left.%]="c.componentPositionX / 30 * 100" [style.top]="c.componentPositionY > 0 ? (c.componentPositionY / 30 * 100) + '%' : 'auto'">
                            <div class="overflow-hidden flex-w-full">
                                <app-drake-custom-component [config]="c" [baseData]="baseData"
                                    (outputEvent)="onValueChange($event)" [mainRecord]="mainRecord">
                                </app-drake-custom-component>
                            </div>
                        </div>
                    </div>

                    <div class="drk-tab-content" *ngIf="!tab.tabMode || tab.tabMode == 'STD'">
                        <kendo-tilelayout [style.width]="'100%'" [style.height]="'100%'" [columns]="30" [rowHeight]="'50px'" [gap]="16">
                            <kendo-tilelayout-item *ngFor="let c of tab.tabComponents"
                                [hidden]="c.componentVisible === false" [col]="c.componentPositionX"
                                [colSpan]="c.componentSizeW" [row]="c.componentPositionY" [rowSpan]="c.componentSizeH">
                                <kendo-tilelayout-item-header>
                                    <div class="flex items-start justify-between" *ngIf="c.componentShowHeader">
                                        <div class="mt-1">
                                            <h5 class="header-text">{{ c.componentName | transloco}}</h5>
                                        </div> 
                                        <div *ngIf="!readonly && (c?.componentDescription | transloco)">
                                            <mat-icon [svgIcon]="'heroicons_solid:information-circle'" [title]="c?.componentDescription | transloco"></mat-icon>
                                        </div>
                                    </div>
                                </kendo-tilelayout-item-header>
                                <kendo-tilelayout-item-body>
                                    <app-drake-custom-component [config]="c" [baseData]="baseData"
                                        (outputEvent)="onValueChange($event)" [mainRecord]="mainRecord" [pageData]="pageData">
                                    </app-drake-custom-component>
                                </kendo-tilelayout-item-body>
                            </kendo-tilelayout-item>
                        </kendo-tilelayout>
                    </div>
                </ng-template>

                <kendo-tabstrip *ngIf="pageData?.pagMode !== 'WIZ' && pageData?.pageTabs?.[0]?.tabMode !== 'FRE'" (tabSelect)="onTabSelect($event)" [keepTabContent]="true">
                    <kendo-tabstrip-tab [title]="tab.tabTitle | transloco" [selected]="i == 0" *ngFor="let tab of pageData?.pageTabs; index as i">
                        <ng-template kendoTabContent>
                            <ng-container *ngTemplateOutlet="tabContentTemplate; context: { tab: tab }"></ng-container>
                        </ng-template>
                    </kendo-tabstrip-tab>
                </kendo-tabstrip>

                <div *ngIf="pageData?.pagMode !== 'WIZ' && (pageData?.pagMode === 'FRE' || pageData?.pageTabs?.[0]?.tabMode === 'FRE')" class="drk-fre-wrapper w-full h-full relative">
                    <ng-container *ngFor="let tab of pageData?.pageTabs">
                        <ng-container *ngTemplateOutlet="tabContentTemplate; context: { tab: tab }"></ng-container>
                    </ng-container>
                </div>

                <div *ngIf="pageData?.pagMode === 'WIZ'" class="drk-wizard-wrapper bg-white p-6 rounded-lg shadow-sm flex flex-col min-h-[700px]">
                    
                    <kendo-stepper 
                        [steps]="wizardSteps" 
                        [stepType]="'full'"
                        [(currentStep)]="currentWizardStep" 
                        [linear]="false" 
                        class="mb-8 drk-horizontal-stepper shrink-0">
                    </kendo-stepper>

                    <div class="relative flex-auto w-full h-full overflow-y-auto overflow-x-hidden p-2">
                        <ng-container *ngIf="pageData?.pageTabs[currentWizardStep] as currentTab">
                            <ng-container *ngTemplateOutlet="tabContentTemplate; context: { tab: currentTab }"></ng-container>
                        </ng-container>
                    </div>

                    <div class="flex justify-center mt-8 space-x-4 shrink-0 border-t pt-6">
                        <button *ngIf="(showButtons && showPrevButton && currentWizardStep > 0)" kendoButton (click)="prevStep()" class="px-6 rounded-full">
                            Indietro
                        </button>
                        
                        <button *ngIf="(showButtons && showNextButton)" kendoButton themeColor="primary" fillMode="outline" (click)="nextStep()" class="px-8 rounded-full border-blue-500 text-blue-500">
                            {{ currentWizardStep === wizardSteps.length - 1 ? 'Fine' : 'Avanti' }}
                        </button>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>